import { Card, Skeleton } from "@mui/material";
import React from "react";

import { Typography } from "new-components/typography/Typography";

interface ThumbnailSkeletonProps {
  showText?: boolean;
  title: string;
}

export function ThumbnailSkeleton(props: ThumbnailSkeletonProps) {
  const { showText, title } = props;
  return (
    <Card
      id="skeleton-card"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 0,
        backgroundColor: "grey.200",
        height: "100%",
        width: "100%",
      }}
    >
      <div className="h-full w-full" style={{ position: "relative" }}>
        <Skeleton data-testid="thumbnailSkeleton" variant="rectangular" className="h-full w-full" />
        {showText &&
          <Typography
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              fontSize: "1rem",
              lineHeight: "1.2rem",
              color: "#535353",
            }}
          >
            There are not yet any {title.toUpperCase()} image queries for this detector
          </Typography>
        }
      </div>
    </Card>
  );
}
